var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomContainer', {
    attrs: {
      "customClass": "image-gallery-continue-edit"
    }
  }, [_c('CustomContainer', {
    attrs: {
      "customClass": "image-gallery-continue-edit-description"
    }
  }, [_c('CustomText', {
    attrs: {
      "elementType": "h4",
      "text": _vm.addYourImageGalleryChosseSizeTitle
    }
  }), _c('CustomText', {
    attrs: {
      "elementType": "p",
      "text": _vm.addYourImageGalleryDescription
    }
  })], 1), _c('custom-container', {
    attrs: {
      "id": "confirm-3d-scene"
    }
  }), !_vm.disableSizeSelector ? _c('CustomContainer', {
    attrs: {
      "customClass": "continue-edit-size-selection"
    }
  }, [_c('CustomText', {
    attrs: {
      "elementType": "h5",
      "customClass": "continue-edit-size-selection-title",
      "text": _vm.translations.addYourImageGallerySizeCopy
    }
  }), _c('SizeSelection', {
    ref: "sizeSelectionContent",
    attrs: {
      "isDisabled": _vm.disableSizeSelect,
      "isLoading": _vm.isPreviewDataLoading
    },
    on: {
      "blockCtaPrimaryButton": _vm.disableAllCtas
    }
  })], 1) : _vm._e(), _c('CustomContainer', {
    attrs: {
      "customClass": "continue-edit-buttons"
    }
  }, [_c('CustomButton', {
    attrs: {
      "customClass": "button primary",
      "type": "button",
      "isDisabled": _vm.disabledCta,
      "text": _vm.translations.addYourImageGalleryContinueToCustomize
    },
    on: {
      "click": function click($event) {
        return _vm.ctaPrimaryAction();
      }
    }
  }), _c('CustomButton', {
    attrs: {
      "customClass": "button secondary",
      "type": "button",
      "isDisabled": _vm.disabledCta,
      "text": _vm.translations.addYourImageGalleryEdit
    },
    on: {
      "click": function click($event) {
        return _vm.ctaSecondaryAction();
      }
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }